import type { MouseEvent } from 'react'
import { initials } from '../lib/initials'
import { signOut } from '../lib/session'

export type Tab = 'new' | 'history'

/** MainLayout's header: brand, the two tabs, and the signed-in account with sign-out. */
export function AppBar({
  active,
  userName,
  onNavigate,
}: {
  active: Tab | null
  userName: string | null
  onNavigate: (tab: Tab) => void
}) {
  const go = (tab: Tab) => (e: MouseEvent<HTMLAnchorElement>) => {
    // A modified click (new tab, new window) keeps the browser's own behaviour.
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return
    e.preventDefault()
    onNavigate(tab)
  }
  const tab = (t: Tab, href: string, icon: string, label: string) => (
    <a
      href={href}
      data-icon={icon}
      className={active === t ? 'active' : undefined}
      aria-current={active === t ? 'page' : undefined}
      onClick={go(t)}
    >
      {label}
    </a>
  )
  return (
    <header className="app-bar">
      <a className="brand" href="/" data-icon="hearing" onClick={go('new')}>
        Hearing Aid Orders
      </a>
      <nav className="tabs">
        {tab('new', '/', 'add_circle', 'New order')}
        {tab('history', '/?view=history', 'history', 'Order history')}
      </nav>
      <div className="account">
        <span className="avatar" aria-hidden="true">
          {initials(userName)}
        </span>
        <span className="user">{userName}</span>
        <form
          className="signout"
          onSubmit={(e) => {
            e.preventDefault()
            void signOut()
          }}
        >
          <button type="submit" className="icon-button" data-icon="logout" title="Sign out" aria-label="Sign out"></button>
        </form>
      </div>
    </header>
  )
}
